/* eslint @typescript-eslint/no-var-requires: "off" */
const objectFitImages = require("object-fit-images");

objectFitImages();